import * as React from "react";
import ViewFilters from "./ViewFilters";
import FilterOverlay from "./FilterOverlay";
import { FilterProp } from "@/types/broadbandProduct";

const MobileFilter: React.FC<{ filterProps: FilterProp[] }> = ({
	filterProps,
}) => {
	const [isMenuActive, setIsMenuActive] = React.useState<boolean>(false);

	const onClick = () => {
		setIsMenuActive(!isMenuActive);
	};

	return isMenuActive ? (
		<FilterOverlay onClick={onClick} filterProps={filterProps} />
	) : (
		<ViewFilters onClick={onClick} />
	);
};

export default MobileFilter;
